import React, { useState, useEffect } from "react";
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Checkbox, Button, makeStyles, Typography, Paper,
    Modal,
    Backdrop,
    Fade,
    Divider,
    InputAdornment,
    TextField
} from "@material-ui/core";
import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SearchIcon from '@mui/icons-material/Search';
import UserService from "../../services/console_services/user";
import AddIcon from '@mui/icons-material/Add';
import { UserModulePopup } from "./userEditModule";
import Loading from "../../common/Components/Loading";
import { UserPopup } from "./addUser";
import EditIcon from '@mui/icons-material/EditOutlined'; // Import Edit icon
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
const useStyles = makeStyles({
    tableContainer: {
        backgroundColor: "#F4F7F9",
        marginLeft: '3vw'
    },
    table: {
        minWidth: 650,
        borderCollapse: "separate", // Allows row separation
        borderSpacing: "0 8px", // Adds space between rows
    },
    headerCell: {
        fontWeight: "bold",
        fontSize: "14px",
        color: "#555",
        backgroundColor: "white", // Header stays white
    },
    row: {
        backgroundColor: "white", // White rows
        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)", // Subtle shadow for rows
    },
    cell: {
        borderBottom: "none",
        fontSize: "14px",
        color: "#333",
        padding: "4px 5px", // Add padding to cells
    },
    actionIcons: {
        cursor: "pointer",
        margin: "0 10px",
    },
    pagination: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 0",
        marginLeft: '3vw'
    },
    blueText: {
        color: '#1D9DDD',
        fontSize: 'small',
        fontWeight: 'bold'
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    modalContent: {
        backgroundColor: "#CCCED0",
        borderRadius: 8,
        padding: "10px",
        width: "30vw",
        height: "90vh",
        boxShadow: 5,
        outline: "none",
        overflow: 'auto', // Allows scrolling, but hides scrollbar
        // Hide scrollbar for webkit browsers
        '&::-webkit-scrollbar': {
            display: 'none',
        }
    },
    section: {
        marginBottom: "15px",
    },
    title: {
        fontSize: "16px",
        fontWeight: "bold",
        color: "#333",
    },
    paperRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    paperRowHeader: {
        fontWeight: "bold",
        color: "#555",
    },
    checkbox: {
        color: "black",
    },
    userLevel: {
        fontSize: "12px",
    },
    closeButton: {
        marginTop: "20px",
        display: "block",
        marginLeft: "auto",
    },
    loaderContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '90vh',
    },
});



const UserAccManagement = () => {
    const classes = useStyles();
    const [popupOpen, setPopupOpen] = useState(false);
    const [addUserPopupOpen, setAddUserPopupOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState([]);
    // const [myData, setMyData] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedUser, setSelectedUser] = useState(null); // State to hold selected user data
    const [modules, setModules] = useState([]);
    const [editModules, setEditModules] = useState([]);
    // Handle edit button click
    const handleEdit = (user) => {
        setSelectedUser(user); // Set the selected user for editing
        setAddUserPopupOpen(true); // Open the user popup
    };

    const handleCloseAddUser = () => {
        setAddUserPopupOpen(false);
        setSelectedUser(null); // Clear selected user after closing
    };
    useEffect(() => {
        fetchUserData();
        fetchUserDataMe();
        fetchModules();
    }, []);
    const fetchUserData = async () => {
        setLoading(true);
        try {
            const response = await UserService.getUser();
            if (response?.data) {
                setUserData(response?.data);
            }
        } catch (error) {
            console.error('Error fetching alerts:', error);
        } finally {
            setLoading(false);
        }
    };
    const fetchModules = async () => {
        setLoading(true);
        try {
            const response = await UserService.getUserModules();
            if (response?.data) {
                setModules(response?.data);
            }
        } catch (error) {
            console.error('Error fetching alerts:', error);
        } finally {
            setLoading(false);
        }
    };
    const fetchUserDataMe = async () => {
        setLoading(true);
        try {
            const response = await UserService.getUserMe();
            if (response?.data) {
                // setMyData(response?.data);
                console.log(response?.data);
            }
        } catch (error) {
            console.error('Error fetching alerts:', error);
        } finally {
            setLoading(false);
        }
    };
    const userDelete = async (_id) => {
        // const response = await UserService.deleteUser(id);
        fetchUserData();
    };
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const filteredData = userData.filter(user =>
        (user.UserID || "").toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleOpenPopup = (accType) => {
        setPopupOpen(true);
        setEditModules(accType);

    };

    const handleOpenAddUser = () => {
        setAddUserPopupOpen(true);

    };
    const handleClosePopup = () => {
        setPopupOpen(false);
    };

    const handleDelete = (id) => {
        userDelete(id);
    };

    return (
        <>
            {loading ? (
                <div className={classes.loaderContainer}>
                    <Loading />
                </div>
            ) : (
                <div style={{ paddingLeft: "20px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: "10px" }}>
                        <Typography variant="h6"></Typography> {/* Optional Title */}
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <Paper
                                elevation={3}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    width: "25px",
                                    height: "25px",
                                    cursor: "pointer",
                                }}
                                onClick={() => handleOpenAddUser()}
                            >
                                <AddIcon style={{ color: "#1976d2" }} /> {/* Icon with color */}
                            </Paper>
                            <TextField
                                variant="outlined"
                                placeholder="Search by User ID"
                                value={searchTerm}
                                onChange={handleSearchChange}
                                InputProps={{
                                    style: {
                                        height: "5vh",
                                        width: "30vw",
                                        backgroundColor: "white",
                                        borderRadius: "10px",
                                        fontSize: "small",
                                    },
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <SearchIcon style={{ color: "#aaa" }} />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </div>
                    </div>
                    <TableContainer
                        component={Paper}
                        className={classes.tableContainer}
                        style={{ maxHeight: "80vh", overflow: "auto" }} // Set max height for scrollable content
                    >
                        <Table className={classes.table} stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        style={{
                                            position: "sticky",
                                            top: 0,
                                            backgroundColor: "#fff",
                                            zIndex: 1,
                                        }}
                                    >
                                        <Checkbox color="primary" />
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            position: "sticky",
                                            top: 0,
                                            backgroundColor: "#fff",
                                            zIndex: 1,
                                        }}
                                    >
                                        User ID
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            position: "sticky",
                                            top: 0,
                                            backgroundColor: "#fff",
                                            zIndex: 1,
                                        }}
                                    >
                                        User Level
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            position: "sticky",
                                            top: 0,
                                            backgroundColor: "#fff",
                                            zIndex: 1,
                                        }}
                                    >
                                        Modules & Access
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            position: "sticky",
                                            top: 0,
                                            backgroundColor: "#fff",
                                            zIndex: 1,
                                        }}
                                    >
                                        Edit User & Delete
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {userData && filteredData &&
                                    filteredData?.map((user, rowIndex) => (
                                        <TableRow key={rowIndex} className={classes.row}>
                                            <TableCell className={classes.cell}>
                                                <Checkbox color="primary" />
                                            </TableCell>
                                            <TableCell className={classes.cell}>
                                                {user.Name || user.UserID}
                                            </TableCell>
                                            <TableCell className={classes.cell}>
                                                {user.Level}
                                            </TableCell>
                                            <TableCell className={classes.cell}>
                                                {user.AccessDetails?.map((access, accessIndex) => (
                                                    <span
                                                        key={accessIndex}
                                                        style={{
                                                            display: "inline-block",
                                                            marginRight: "20px",
                                                        }}
                                                    >
                                                        <Typography
                                                            style={{ marginRight: "15px" }}
                                                        >
                                                            {access.ModuleName}
                                                        </Typography>
                                                        <Typography
                                                            className={classes.blueText}
                                                            display="inline"
                                                            style={{
                                                                marginRight: "15px",
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            {access.AccessType}
                                                        </Typography>
                                                    </span>
                                                ))}
                                            </TableCell>
                                            <TableCell className={classes.cell} style={{ width: '20vw' }}>
                                                <IconButton
                                                    aria-label="edit"
                                                    className={classes.actionIcons}
                                                    onClick={() => handleOpenPopup(user)}
                                                >
                                                    <AdminPanelSettingsOutlinedIcon />
                                                </IconButton>
                                                <IconButton
                                                    aria-label="delete"
                                                    className={classes.actionIcons}
                                                    onClick={() => handleDelete(user)}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                                <IconButton
                                                    aria-label="edit"
                                                    className={classes.actionIcons}
                                                    onClick={() => handleEdit(user)}
                                                >
                                                    <EditIcon />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <div className={classes.pagination}>
                        <Typography>Showing 10 results out of 180</Typography>
                    </div>
                    <UserModulePopup open={popupOpen} onClose={handleClosePopup} modules={modules} editModules={editModules} fetchUserData={fetchUserData} />
                    <UserPopup open={addUserPopupOpen} onClose={handleCloseAddUser} fetchUserData={fetchUserData} selectedUser={selectedUser} />
                </div>
            )}

        </>
    );
};

export default UserAccManagement;
